import config from '../../config';

const TILE_SIZE = config.TILE_SIZE;
const TILE_SIZE_HALF = TILE_SIZE / 2;
const UP = config.UP;
const DOWN = config.DOWN;
const LEFT = config.LEFT;
const RIGHT = config.RIGHT;

function getStepPos (direction, x, y, step) {
  let pos = { x, y };
  switch (direction) {
    case UP:
      pos.y -= TILE_SIZE * step;
      break;
    case DOWN:
      pos.y += TILE_SIZE * step;
      break;
    case LEFT:
      pos.x -= TILE_SIZE * step;
      break;
    case RIGHT:
      pos.x += TILE_SIZE * step;
      break;
  }
  return pos;
}

function Layer (name) {
  return {
    name: name,
    groups: {
      tiles: []
    }
  };
}

export {
  getStepPos,
  Layer
};
